module.exports = __webpack_public_path__ + "img/stephane-bourez-escapee.25096bf.jpg";